import React from "react";
import { useVideoComments } from "../Hooks/Comments/Video/useVideoComments";
import CommentsDiscussion from "./CommentsDiscussion";

export { pinnedByLabel } from "./CommentsDiscussion";

interface VideoCommentsProps {
    videoId: number | undefined;
    onComposerFocusChange?: (focused: boolean) => void;
}

const VideoComments: React.FC<VideoCommentsProps> = ({ videoId, onComposerFocusChange }) => {
    const controller = useVideoComments(videoId);
    return <CommentsDiscussion controller={controller} contentType="video" onComposerFocusChange={onComposerFocusChange} />;
};

export default VideoComments;
